import { getFeatureFlagsService } from '@/services/featureFlags';
import { useQuery } from '@tanstack/react-query';

export const useGetFeatureFlags = (companyUuid?: string) => {
  const { data, isPending } = useQuery({
    queryKey: ['featureFlags'],
    queryFn: () => getFeatureFlagsService(companyUuid),
    staleTime: Infinity,
    retry: false,
    enabled: !!companyUuid,
  });

  return {
    featureFlags: data,
    isPendingFeatureFlags: isPending,
  };
};
